module.exports = __webpack_public_path__ + "static/media/picture1.502c4df3.png";